import React from "react";
import { Card } from "../../components/Card";
import { useMultiFanCriteriaForm } from "./useMultiFanCriteriaForm";
import { MultiFanCriteriaForm } from "./MultiFanCriteriaForm";
import { MultiFanVisualisation } from "./MultiFanVisualisation";
import { useCalculateMultiFanNoise } from "./useCalculateMultiFanNoise";
import { MultiFanCalculationResults } from "./MultiFanCalculationResults";
import {Protected} from "../../layout/Protected";

export function MultiFanNoisePage() {
    const {
        multiFanCriteria,
        formData,
        handleFieldChange,
        handleObserverPositionChange,
        handleCalculate,
        updateSvg
    } = useMultiFanCriteriaForm();

    const multiFanNoiseResults = useCalculateMultiFanNoise(multiFanCriteria, updateSvg);

    return (
        <Protected privilege={"PERM_MULTI_FAN_ACOUSTIC"}>
            <Card
                header="Akustyka wielu chłodnic"
                subHeader="Kalkulacja hałasu w celach szacunkowych"
                additionalClassNames="mb-3"
            >
                <h2>Kryteria obliczeń</h2>
                    <MultiFanCriteriaForm
                        formData={formData}
                        onFieldChange={handleFieldChange}
                        onObserverPositionChange={handleObserverPositionChange}
                        onCalculate={handleCalculate}
                        totalFanCount={multiFanCriteria.totalFanCount}
                        error={multiFanCriteria.error}
                    />
                <h2 className={"mt-5"}>Wizualizacja</h2>
                    <MultiFanVisualisation
                        svg={multiFanCriteria.svg}
                        error={multiFanCriteria.error}
                    />

                {multiFanNoiseResults && (
                    <div className="mt-5">
                        <MultiFanCalculationResults results={multiFanNoiseResults} />
                    </div>
                )}

            </Card>
        </Protected>
    );
}